module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon8.fe49c6e5.svg";